var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Input from '../../Components/ComponentInput';
import Checkbox from '../../Components/ComponentCheckbox';
import Button from '../../Components/ComponentButton';
import T from './Locale';
import isPasswordValid from '../../Utils/IsPasswordValid';
import axios from 'axios';
import Consents from './Consents';
const SignupModalConsents = ({ user, email, goToNextPage, isNewUser = true, partner }) => {
    const [internalUser, setInternalUser] = useState(user);
    const [errors, setErrors] = useState({});
    const [isLoading, toggleLoading] = useState(false);
    let consents = [];
    if (partner.consent) {
        consents = Array.isArray(partner.consent.consents) ? partner.consent.consents : Object.values(partner.consent.consents);
        consents = consents.filter(consent => consent.visible.includes('SignupModal'));
    }
    /**
     * Update field on the user and remove any errors for the field.
     *
     * @param {string} field
     * @param {string} value
     */
    const updateField = (field, value) => {
        const newErrors = Object.assign({}, errors);
        // Delete any previous error for the field.
        delete newErrors[field];
        setErrors(newErrors);
        // Update the value for the field on the user.
        setInternalUser(Object.assign(Object.assign({}, internalUser), { [field]: value }));
    };
    /**
     * Toggle the consents for the user.
     *
     * @param {string} consentId
     * @param {string} value
     * @param {array} consentsToAdd
     * @param {array} consentsToRemove
     */
    const updateConsents = (consentId, value, consentsToAdd, consentsToRemove) => {
        const existingConsents = Array.isArray(user.consents) ? user.consents : [];
        const newConsents = existingConsents
            .filter((consent) => consentsToRemove.indexOf(consent) === -1)
            .concat(consentsToAdd);
        setInternalUser(Object.assign(Object.assign({}, internalUser), { [consentId]: value, consents: newConsents }));
    };
    /**
     * Validate the input, and set any errors.
     *
     * @returns {boolean}
     */
    const validate = () => __awaiter(void 0, void 0, void 0, function* () {
        toggleLoading(true);
        const newErrors = {};
        const missingConsents = consents
            .filter(consent => consent.required === true && !internalUser[consent.text.replace(/[^a-z]/g, '')])
            .map(consent => consent.text.replace(/[^a-z]/g, ''));
        missingConsents.forEach((missingConsent) => {
            newErrors[missingConsent] = true;
        });
        if (isNewUser) {
            if (!isPasswordValid(internalUser.password)) {
                newErrors.password = T('partner.modal.errors.password');
            }
            if (internalUser.password !== internalUser.passwordRepeated) {
                newErrors.passwordRepeated = T('partner.modal.errors.passwordRepeat');
            }
            if (!internalUser.conditions) {
                newErrors.conditions = T('partner.modal.errors.conditions');
            }
        }
        else {
            try {
                yield axios.post('/api/user/authenticate', { email, password: internalUser.password }, { withCredentials: true });
            }
            catch (exception) {
                newErrors.password = T('partner.modal.errors.passwordWrong');
            }
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    });
    /**
     * Validate all fields on page and go to next page.
     */
    const save = () => __awaiter(void 0, void 0, void 0, function* () {
        const isValid = yield validate();
        if (!isValid) {
            toggleLoading(false);
        }
        if (isValid) {
            goToNextPage(internalUser);
        }
    });
    return (_jsxs("div", { children: [_jsx("p", Object.assign({ className: 'mb-1' }, { children: T('partner.modal.email') })), _jsx(Input, { value: email, isDisabled: true }), _jsx("br", {}), _jsxs("div", Object.assign({ className: 'help-text-block' }, { children: [_jsx("p", Object.assign({ className: 'mb-1' }, { children: T('partner.modal.password') })), _jsx(Input, { id: 'password', type: 'password', hint: isNewUser ? T('partner.modal.passwordHint') : T('partner.modal.passwordInput'), onChange: (value) => updateField('password', value), value: internalUser.password, error: errors.password, hintClasses: 'tailwind-reset mb-4' }), isNewUser && (_jsxs(_Fragment, { children: [_jsx("p", Object.assign({ className: 'mb-1' }, { children: T('partner.modal.passwordRepeat') })), _jsx(Input, { id: 'passwordRepeat', type: 'password', onChange: (value) => updateField('passwordRepeated', value), value: internalUser.passwordRepeated, error: errors.passwordRepeated }), _jsx("br", {})] }))] })), isNewUser && (_jsx("div", Object.assign({ className: 'mb-4' }, { children: _jsx(Checkbox, { id: 'conditions', label: T('partner.modal.conditions'), onChange: (isChecked) => updateField('conditions', isChecked), startChecked: user.conditions, error: errors.conditions }) }))), consents.map((consent) => (_jsx(Consents, { consent: consent, onChange: updateConsents, error: consent.required && errors[consent.text.replace(/[^a-z]/g, '')] }, consent.text.replace(/[^a-z]/g, '')))), _jsx("br", {}), _jsx("br", {}), _jsx("div", Object.assign({ className: 'text-center' }, { children: _jsx(Button, { id: 'next', title: T('partner.modal.next'), classes: 'purple mb-5', onClick: save, isLoading: isLoading }) }))] }));
};
SignupModalConsents.propTypes = {
    user: PropTypes.object.isRequired,
    email: PropTypes.string.isRequired,
    goToNextPage: PropTypes.func.isRequired,
    isNewUser: PropTypes.bool,
    partner: PropTypes.object.isRequired
};
export default SignupModalConsents;
